import React, { FC } from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import ContentLoader from '@adsk/alloy-react-content-loader';
import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';

const TableContentTitleLoader: FC = () => {
  return (
    <Flex width="100%">
      <Box flex={1}>
        <ContentLoader
          height={46}
          width="150"
          backgroundColor={theme.colors.charcoal200}
        >
          <rect height="36" rx="8" ry="8" width="150" x="0" y="0" />
        </ContentLoader>
      </Box>
      <Flex style={{ gap: theme.spacing.small }}>
        <Box
          height="32px"
          width="118px"
          border={`1px solid ${theme.colors.charcoal200}`}
          borderRadius={8}
        />
        <Box
          height="32px"
          width="118px"
          border={`1px solid ${theme.colors.charcoal200}`}
          borderRadius={8}
        />
        <Box
          height="32px"
          width="32px"
          border={`1px solid ${theme.colors.charcoal200}`}
          borderRadius={8}
          backgroundColor={theme.colors.charcoal100}
        />
        <Box
          height="32px"
          width="32px"
          border={`1px solid ${theme.colors.charcoal200}`}
          borderRadius={8}
          backgroundColor={theme.colors.charcoal100}
        />
      </Flex>
    </Flex>
  );
};

const TableHeaderCellLoader: FC = () => {
  return (
    <th scope="column">
      <Flex>
        <ContentLoader
          height={35}
          viewBox="0 0 104 35"
          backgroundColor={theme.colors.charcoal200}
          foregroundColor={theme.colors.charcoal100}
        >
          <rect height="16" rx="8" ry="8" width="104" x="0" y="12" />
        </ContentLoader>
      </Flex>
    </th>
  );
};

const TableContentLoader: FC = () => {
  return (
    <Flex flex={1} flexDirection="column">
      <TableContentTitleLoader />
      <table>
        <thead>
          <tr>
            {Array.from({ length: 5 }).map((_, index) => (
              <TableHeaderCellLoader key={`TableHeaderCellLoader_${index}`} />
            ))}
          </tr>
          <tr>
            <td colSpan={5}>
              <Divider />
            </td>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 6 }).map((_, index) => (
            <tr key={`TableContentLoader_row_${index}`}>
              <th>
                <Flex
                  height="100%"
                  width="100%"
                  alignItems="center"
                  paddingY={theme.spacing.M}
                >
                  <ContentLoader height={40} width={250}>
                    <rect height="10" rx="6" ry="6" width="200" x="30" y="2" />
                    <rect height="10" rx="6" ry="6" width="104" x="30" y="15" />
                    <rect
                      height="25"
                      rx="100"
                      ry="100"
                      width="25"
                      x="0"
                      y="0"
                    />
                  </ContentLoader>
                </Flex>
              </th>
              <th>
                <Flex height="100%" alignItems="center" minWidth={125}>
                  <ContentLoader height={40} width={100}>
                    <rect
                      height="15"
                      rx="100"
                      ry="100"
                      width="15"
                      x="0"
                      y="0"
                    />
                    <rect
                      height="15"
                      rx="100"
                      ry="100"
                      width="15"
                      x="25"
                      y="0"
                    />
                    <rect
                      height="15"
                      rx="100"
                      ry="100"
                      width="15"
                      x="50"
                      y="0"
                    />
                    <rect
                      height="15"
                      rx="100"
                      ry="100"
                      width="15"
                      x="75"
                      y="0"
                    />
                    <rect
                      height="15"
                      rx="100"
                      ry="100"
                      width="15"
                      x="100"
                      y="0"
                    />
                  </ContentLoader>
                </Flex>
              </th>
              <th>
                <Flex
                  height="100%"
                  width="auto"
                  alignItems="center"
                  paddingRight={theme.spacing.M}
                >
                  <ContentLoader height={40}>
                    <rect height="10" rx="6" ry="6" width="300" x="0" y="0" />
                  </ContentLoader>
                </Flex>
              </th>
              <th>
                <Flex height="100%" alignItems="center" width={190}>
                  <ContentLoader height={40}>
                    <rect height="10" rx="6" ry="6" width="190" x="0" y="0" />
                  </ContentLoader>
                </Flex>
              </th>
              <th>
                <Flex height="100%" alignItems="center" width={190}>
                  <ContentLoader height={40}>
                    <rect height="10" rx="6" ry="6" width="190" x="0" y="0" />
                  </ContentLoader>
                </Flex>
              </th>
            </tr>
          ))}
        </tbody>
      </table>
    </Flex>
  );
};

export const TableLoader: FC = () => {
  return (
    <Flex flex={1} paddingY={theme.spacing.L}>
      <TableContentLoader />
    </Flex>
  );
};

export default TableLoader;
